import { Component, Input } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'view-report-btn',
  templateUrl: 'view-report-btn.component.html',
  styleUrls: ['view-report-btn.component.scss']
})
export class ViewReportBtnComponent {
  @Input() status: number = 1; // 1 - success, 2 - partial failure, 3 - total failure
}
